module.exports = __webpack_public_path__ + "static/media/usa.60faee64.jpg";